/**
 * @generated SignedSource<<81352ac5a0db626e6cc9f0c09f517865>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeliveryOrderXlsxCreateInput = {
  commit: boolean;
  file: Upload;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation$variables = {
  input: DeliveryOrderXlsxCreateInput;
};
export type DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation$data = {
  readonly deliveryOrderXlsxCreate: {
    readonly committed: boolean;
    readonly createdCount: number;
    readonly issues: ReadonlyArray<{
      readonly field: string;
      readonly kind: string;
      readonly message: string;
      readonly row: number;
    }>;
    readonly totalCount: number;
    readonly validCount: number;
  };
};
export type DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation = {
  response: DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation$data;
  variables: DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeliveryOrderXlsxCreateResult",
    "kind": "LinkedField",
    "name": "deliveryOrderXlsxCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "committed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DeliveryOrderXlsxIssue",
        "kind": "LinkedField",
        "name": "issues",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "row",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "abb9127c8f912a1dc347b8542a59c1ca",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation",
    "operationKind": "mutation",
    "text": "mutation DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateMutation(\n  $input: DeliveryOrderXlsxCreateInput!\n) {\n  deliveryOrderXlsxCreate(input: $input) {\n    committed\n    totalCount\n    validCount\n    createdCount\n    issues {\n      row\n      kind\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "696dc08cc71d186a841b526cb118e1db";

export default node;
